import fr from 'facet-rest';
import { Table } from '@facet-wealth/design';
import { dayOfMonth, fullDateAtTime } from 'Consts/DateFormats';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  BoolColumn,
} from 'Views/Page/Content/Templates/GenericTableTemplate/MainContent/ItemListPicker/ItemList/ItemTable/boolColumn';

export const metaOverrideSet = fr.metaOverride()
  .overrideAll({
    _component: () => Table.BodyCellText,
  }, {
    ordinal: 200,
  })
  .typeOverride('number', {
    _component: () => Table.BodyCellNumber,
  }, {
    ordinal: 200,
  })
  .typeOverride('date', {
    _formatString: dayOfMonth,
  }, {
    ordinal: 200,
  })
  .typeOverride('bool', {
    _component: () => BoolColumn,
  }, overrideReadOnly)
  .override({ isDateTime: true }, {
    _displayTime: true,
    _formatString: fullDateAtTime,
  }, {
    ordinal: 200,
  });
